import { User, UserRole } from "../types";
import { apiRequest } from "./api";

// Get family by ID
export const getFamily = async (familyId: string) => {
  try {
    const response = await apiRequest(`/api/families/${familyId}`, "GET");
    return response;
  } catch (error) {
    console.error("Error fetching family:", error);
    throw new Error("Family not found");
  }
};

// Get family members
export const getFamilyMembers = async (familyId: string): Promise<User[]> => {
  try {
    const response = await apiRequest(
      `/api/families/${familyId}/members`,
      "GET"
    );
    return response;
  } catch (error) {
    console.error("Error fetching family members:", error);
    throw error;
  }
};

// Invite a user to a family
export const inviteToFamily = async (
  familyId: string,
  email: string,
  role: string = "CHILD"
): Promise<void> => {
  try {
    await apiRequest(`/api/families/${familyId}/invitations`, "POST", {
      email: email,
      role: role,
    });
    console.log(
      `Invitation sent to ${email} for family ${familyId} with role ${role}`
    );
  } catch (error) {
    console.error("Error sending invitation:", error);
    throw error;
  }
};

// Resend an existing invitation
export const resendInvitation = async (invitationId: string): Promise<void> => {
  try {
    await apiRequest(`/api/invitations/${invitationId}/resend`, "POST");
    console.log(`Invitation ${invitationId} resent successfully`);
  } catch (error) {
    console.error("Error resending invitation:", error);
    throw error;
  }
};

// Remove a user from a family
export const removeFamilyMember = async (
  familyId: string,
  userId: string
): Promise<void> => {
  try {
    await apiRequest(`/api/families/${familyId}/members/${userId}`, "DELETE");
    console.log(`User ${userId} removed from family ${familyId}`);
  } catch (error) {
    console.error("Error removing family member:", error);
    throw error;
  }
};

// Update family member role
export const updateFamilyMemberRole = async (
  familyId: string,
  userId: string,
  role: UserRole
): Promise<User> => {
  try {
    const response = await apiRequest(
      `/api/families/${familyId}/members/${userId}/role`,
      "PUT",
      { role: role }
    );
    console.log(`User ${userId} role updated to ${role} in family ${familyId}`);
    return response;
  } catch (error) {
    console.error("Error updating member role:", error);
    throw error;
  }
};

// Update family name
export const updateFamilyName = async (
  familyId: string,
  name: string
): Promise<void> => {
  try {
    await apiRequest(`/api/families/${familyId}`, "PUT", { name: name });
    console.log(`Family ${familyId} name updated to "${name}"`);
  } catch (error) {
    console.error("Error updating family name:", error);
    throw error;
  }
};

// Update family settings
export const updateFamilySettings = async (
  familyId: string,
  settings: { name?: string; weekStartDay?: number }
): Promise<void> => {
  try {
    await apiRequest(`/api/families/${familyId}`, "PUT", settings);
    console.log(`Family ${familyId} settings updated:`, settings);
  } catch (error) {
    console.error("Error updating family settings:", error);
    throw error;
  }
};
